// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nqDI","textarea":"styles_textarea__2iwEi"};